import CryptoJS from "crypto-js";

//是否正式服，需要在外部修改此变量
const isRelease = true;

const testCryptoKey = "tHctJZaC5Dx6pWYrj68vo28j9pPAzfo=";
const testCryptoIv = "RDlhO/GW+LFmOWQU";
const releaseCryptoKey = "U41U5FeIj0uhOKnzgWZ1MBBC6iEUF2DZ";
const releaseCryptoIv = "4Y535fZnkQ57BVoq";

const testRouteCrypKey = "kjhlouyuf20987677869887978987277";
const testRouteCrypIv = "kjhlouyuf2098767";
const releaseRouteCrypKey = "8dw/JfjjoMs0dzVGOX2ntb1iw2k9+JD4";
const releaseRouteCrypIv = "ZGdIobme/Sb4Idwg";

function cryptoKey() {
  if (isRelease) {
    return releaseCryptoKey;
  } else {
    return testCryptoKey;
  }
}

function cryptoIv() {
  if (isRelease) {
    return releaseCryptoIv;
  } else {
    return testCryptoIv;
  }
}

function routeCrypKey() {
  if (isRelease) {
    return releaseRouteCrypKey;
  } else {
    return testRouteCrypKey;
  }
}

function routeCrypIv() {
  if (isRelease) {
    return releaseRouteCrypIv;
  } else {
    return testRouteCrypIv;
  }
}

//加密客户端发送的内容
function aesEncrptMsg(msg: string) {}
function aesDecryptMsg(msg: string) {}
function aesDecrptHost(host: string) {}

function decodeMsg(msg: string) {
  const tmp = msg.trim();
  if (!tmp) {
    return "";
  }
  if (tmp.charAt(0) == "{") {
    return msg;
  }
  //有出现server 底层被拦截直接返回客户端一个html 页面，导致底层解密失败报错
  if (
    tmp.indexOf("<html") > 0 ||
    tmp.indexOf(" ") > 0 ||
    tmp.indexOf("\t") > 0 ||
    tmp.indexOf(">") > 0
  ) {
    return "";
  }
  return aesDecryptWithNoPadding(msg);
}

function aesDecryptWithNoPadding(msg: string) {}

export function aesEncryptWithCommonKey(msg: string) {
  return aesEncrypt(cryptoKey(), cryptoIv(), msg);
}

function aesEncrypt(cryptoKey: string, cryptoIv: string, msg: string) {
  const key = CryptoJS.enc.Utf8.parse(cryptoKey);
  const iv = CryptoJS.enc.Utf8.parse(cryptoIv);
  const encrypt = CryptoJS.AES.encrypt(msg, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypt.toString();
}

export function aesDcryptWithPKC27(msg: string) {
  try {
    const key = CryptoJS.enc.Utf8.parse(cryptoKey());
    const iv = CryptoJS.enc.Utf8.parse(cryptoIv());
    const decrypted = CryptoJS.AES.decrypt(msg, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error(error);
    return "";
  }
}

export async function rsaEncrypt(str: string) {
  const jsencrypt = await import("@repo/jsencrypt");
  const encryptStr = new jsencrypt.JSEncrypt();
  encryptStr.setPublicKey(`-----BEGIN public key-----
  		MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDXQOEgrBjXpV0CsHnJIYmJy40a
  		wBH3jqKB/SP8kHKt3gLQOPWy3hqp080GfK7AEdWe6YgZquJCPgfrvbFUo9pveyiN
  		OEH2QloCkRTn/lVzVCWPXWtzuT8YCAwWgbZ68h6ETwKX9BsZE+0+4+qgIq0+ckhe
  		9zKerADZwURzeDiLLwIDAQAB
  		-----END public key-----`);
  return `r:${encryptStr.encrypt(str)}`;
}

export function getDecString(val: string) {
  try {
    const keys = CryptoJS.enc.Utf8.parse("E8aTO43VgyMeFZUw");
    const iv = CryptoJS.enc.Utf8.parse("PWeJViG1mum5DmJ1");
    const keyEncrypted = CryptoJS.AES.decrypt(val, keys, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.ZeroPadding,
    });
    return keyEncrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    return val;
  }
}
